import { LoanOptionBlockMobile } from "./LoanOptionBlockMobile";
import { LoanOptionBlock } from "./LoanOptionBlock";

export const LoanOptionBlockCombo = (props) => {
  return (
    <div className="loan-option-block-combo-wrapper">
      <div className="only-visible-on-desktop">
        <LoanOptionBlock {...props} />
      </div>
      <div className="only-visible-on-mobile">
        <LoanOptionBlockMobile {...props} />
      </div>
    </div>
  );
};
